<form class="dynamic-form" [formGroup]="form" (submit)="handleSubmit($event)">
  @for (field of config; track field) {
    <ng-container dynamicField [config]="field" [group]="form">
    </ng-container>
  }
</form>